import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useUA } from 'context'
import gql from 'graphql-tag'
import { useRouter } from 'next/router'
import {
  CoverLetterItemMain_CoverLetterFragment,
  CoverLetterItemMain_CurrentUserFragment,
} from 'generated/graphql'
import useMediaQuery from '@app.modules/hooks/useMediaQuery'
import { getQueryParams } from '../CoverLetterScreen/CoverLetterList/CoverLetterListContent'
import {
  SearchState,
  useSearchStateContext,
} from '../CoverLetterScreen/useSearchState'
import CoverLetterItemDesktopBody from './CoverLetterItemDesktopBody'
import CoverLetterItemMobileBody from './CoverLetterItemMobileBody'
import CoverLetterItemSearchBox from './CoverLetterItemSearchBox'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#fafafa',
    },
  },
}))

interface CoverLetterItemMainProps {
  coverLetter?: CoverLetterItemMain_CoverLetterFragment | null
  currentUser?: CoverLetterItemMain_CurrentUserFragment | null
  highlight?: string[] | null | undefined
}

const getListLink = (context: SearchState) => {
  const queryString = getQueryParams(context)
  return `/cover-letter/search?${queryString}`
}

const tabletBreakPoint = '(min-width: 960px)'

const CoverLetterItemMain: FC<CoverLetterItemMainProps> = ({
  coverLetter,
  currentUser,
  highlight,
}) => {
  const classes = useStyles()
  const router = useRouter()

  const context = useSearchStateContext()
  const listLink = getListLink(context)
  const isSimplePage = Boolean(router?.query?.simple)

  const { isMobile } = useUA()
  const isDesktop = useMediaQuery(tabletBreakPoint, {
    defaultMatches: isMobile ? false : true,
  })

  return (
    <div className={classes.root}>
      <CoverLetterItemSearchBox coverLetterId={coverLetter?.id || undefined} />
      {isDesktop ? (
        <CoverLetterItemDesktopBody
          coverLetter={coverLetter ?? undefined}
          currentUser={currentUser ?? undefined}
          highlight={highlight}
          isSimplePage={isSimplePage}
          listLink={listLink}
          coverLetterId={coverLetter?.id || undefined}
        />
      ) : (
        <CoverLetterItemMobileBody
          coverLetter={coverLetter ?? undefined}
          currentUser={currentUser ?? undefined}
          highlight={highlight}
        />
      )}
    </div>
  )
}

export default CoverLetterItemMain

gql`
  fragment CoverLetterItemMain_currentUser on User {
    ...CoverLetterItemDesktopBody_currentUser
    ...CoverLetterItemMobileBody_currentUser
  }
  fragment CoverLetterItemMain_coverLetter on CoverLetter {
    id
    ...CoverLetterItemDesktopBody_coverLetter
    ...CoverLetterItemMobileBody_coverLetter
  }
`
